import React, { useState, createContext } from "react";

const RestaurentContext = createContext();

export const RestaurentContextProvider = ({ children }) => {
  const [restBanners, setRestBanners] = useState([]);
  const [subStores, setSubStores] = useState([]);

  const [restCat, setRestCat] = useState([]);
  const [restItems, setRestItems] = useState([]);
  const [filterRestItems, setFilterRestItems] = useState([]);

  const [tappedStore, setTappedStore] = useState(null);

  const values = {
    restBanners,
    setRestBanners,
    subStores,
    setSubStores,
    restCat,
    setRestCat,
    restItems,
    setRestItems,
    filterRestItems,
    setFilterRestItems,
    tappedStore,
    setTappedStore,
  };

  return (
    <RestaurentContext.Provider value={values}>
      {children}
    </RestaurentContext.Provider>
  );
};

export default RestaurentContext;
